export function setLocalStorageItem(key: string, value: string) {
  const encode = encodeURIComponent(value);
  localStorage.setItem(key, encode);
}

export function getLocalStorageItem(key: string) {
  const item = localStorage.getItem(key);
  if (!item) {
    return null;
  }
  const decode = decodeURIComponent(item);
  return decode;
}
